module.exports = __webpack_public_path__ + "img/login-logo2.6a8d326d.png";